import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// Central place any authenticated call's expired/invalid-token response gets
// turned into an actual logout. Previously a 401 here only logged to the
// console — every screen showed a "session expired" toast (see
// CommonMethodService.returnErrorMessage) but never actually cleared the
// session or sent the user back to login, so they were stuck looking at a
// dead page. This complements InactivityTimeoutService's idle-based logout:
// that one fires on inactivity: this one fires the moment the SERVER
// rejects the token for any reason (expiry, revocation, clock skew, etc).
@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === 'https://localhost:8443/SGIFPCapture') {
      return next.handle(req);
    }
    const token = sessionStorage.getItem('token');
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token
        }
      });
    }
    return next.handle(req).pipe(
      tap(
        x => x,
        (err: HttpErrorResponse) => {
          console.error(`Error performing request, status code = ${err.status}`);
          // Only an authenticated request going stale should force a logout —
          // a 401 with no token attached is just a failed /authenticate
          // attempt (bad credentials), which login.component.ts already
          // handles on its own (shake animation, no session to clear).
          if (token && err.status === 401) {
            this.forceLogout();
          }
        }
      )
    );
  }

  private forceLogout(): void {
    if (!sessionStorage.getItem('token')) {
      return; // a second in-flight request already triggered this
    }
    sessionStorage.clear();
    // No toast here — CommonMethodService.returnErrorMessage already shows
    // "Session has expired. Please log in again." for this exact 401 case
    // wherever a component calls it on error; this just adds the redirect
    // and session clear that were missing, without a duplicate message.
    this.router.navigate(['/']);
  }
}
